module.exports = __webpack_public_path__ + "img/service-zhinengyingxiao3.2abd97b6.svg";